<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="bg-white p-5 shadow m-2">
      <form id="basic" @submit.prevent="updateCourse">
        <div class="grid grid-cols-2 items-center mt-5">
          <div>
            <div class="text-3xl font-bold inline-block">Edit course</div>
            <br />
            <div class="text-xl inline-block text-gray-600">
              Enter course details
            </div>
          </div>
          <div class="text-right">
            <input
              type="checkbox"
              v-model="publish"
              class="toggle align-middle"
            />
            <div class="text-lg font-bold inline-block ml-3">Publish</div>
            <button
              :disabled="description.trim() && title.trim() === ''"
              type="submit"
              class="btn btn-primary text-lg ml-3"
            >
              Save
            </button>
          </div>
        </div>

        <div class="mt-4">
          <input
            type="text"
            placeholder="Title (required)"
            class="input input-bordered w-full mb-2"
            required
            name="title"
            v-model="title"
            @input="onEdit"
          />
          <textarea
            class="textarea h-64 textarea-bordered w-full mb-1"
            placeholder="Description (required)"
            required
            name="description"
            v-model="description"
            @input="onEdit"
          />
          <div
            class="form-control py-3 w-full"
          >
            <div class="text-xl inline-block">Course Type:</div>

            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="mail"
                v-model="Type"
                @input="onEdit"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Mail</span>
            </label>

            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="twitter"
                v-model="Type"
                @input="onEdit"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Twitter</span>
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="Charge"
                class="checkbox checkbox-primary"
                v-model="Charge"
                @input="
                  onEdit();
                  price = '';
                "
              />
              <span class="label-text text-lg ml-3">Charge for the course</span>
            </label>
          </div>
          <input
            type="number"
            v-if="Charge"
            placeholder="Price (required)"
            class="input input-bordered w-95/100 ml-5/100 mt-2 mb-2"
            required
            min="1"
            oninput="validity.valid||(value='');"
            name="price"
            v-model="price"
            @input="onEdit"
          />
          <div
            class="form-control w-95/100 ml-5/100"
            v-if="Charge"
          >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="PPP"
                class="checkbox checkbox-primary"
                v-model="PPP"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3"
                >Use Purchasing Power Parity</span
              >
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="Limitstudent"
                class="checkbox checkbox-primary"
                v-model="Limitstudent"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Limit Students</span>
            </label>
          </div>
          <input
            type="number"
            v-if="Limitstudent"
            placeholder="Max. Students (required)"
            class="input input-bordered w-95/100 ml-5/100 mt-2 mb-2"
            required
            name="maxStudents"
            min="1"
            oninput="validity.valid||(value='');"
            v-model="maxStudents"
            @input="onEdit"
          />
          <div class="form-control" >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="Threadseries"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Create a thread series</span>
            </label>
          </div>
          <div class="form-control" >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="Enablehashtag"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Enable hashtag submission (premium)</span>
            </label>
          </div>
          <div class="form-control" >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showBackground"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Background ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showCheck"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Check ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showFeedback"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Feedback ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showParticipate"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Participate ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showTakeaway"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Takeaway ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="sharingtips"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Require Registration for sharing tips</span>
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="AllowsubmissionviaDM"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Allow assignment submission via DM </span>
              <span class="label-text text-md ml-3 mt-1">( warn: conversations might be flagged as assignment submissions )</span>
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="linear"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Sequential</span>
            </label>
          </div>
          <div class="form-control">
            <label
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="scheduled"
                @input="onEdit"
              />
              <span class="label-text text-lg ml-3">Scheduled</span>
            </label>
          </div>
          <input
            v-if="scheduled"
            type="datetime-local"
            placeholder="Date-Time"
            class="input input-bordered w-95/100 ml-5/100 mt-2 mb-2"
            required
            name="publishDateTime"
            v-model="publishDateTime"
            @input="onEdit"
          />
          <div
            v-if="scheduled && isNaN(new Date(publishDateTime).getTime())"
            class="text-red-500"
          >
            Please enter valid date time
          </div>
          <select
            v-model="frequency"
            v-if="scheduled"
            class="select select-bordered w-95/100 ml-5/100 mb-2"
            @input="onEdit"
            required
          >
            <option disabled="disabled" value="">Choose frequency</option>
            <option value="DAILY">Daily</option>
            <option value="WEEKLY">Weekly</option>
          </select>
          <div
            v-if="scheduled"
            class="form-control py-3 w-95/100 ml-5/100 mt-2"
          >
            <div class="text-xl inline-block">Deliver course on:</div>
            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="TWEET"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">via Tweets</span>
            </label>
            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="DM"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">via DM</span>
            </label>

            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="SITE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Twitter Engagement</span
              >
            </label>

            <label
              v-if="Type === 'twitter'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="SITE-NOTE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Twitter Notification</span
              >
            </label>

            <label
              v-if="Type === 'mail'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="MAIL"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Mail Engagement</span
              >
            </label>

            <label
              v-if="Type === 'mail'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="MAIL-NOTE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Mail Notification</span
              >
            </label>

          </div>
          <div class="flex">
            <div class="flex-grow">
              <input
                disabled
                type="text"
                placeholder="Image"
                class="input input-bordered w-full mb-2"
                name="img"
                v-model="img"
                @input="onEdit"
              />
            </div>
            <div class="flex-none ml-3">
              <input
                ref="selectedFile"
                class="w-full mt-3 text-indigo-700 outline-none bg-gray-100"
                type="file"
                name="selectedFile"
                style="display: none"
                accept="image/jpeg, image/png"
                @change="onImageUpload"
                @input="onEdit"
              />
              <button
                type="button"
                class="btn btn-outline"
                @click="$refs.selectedFile.click()"
              >
                Select...
              </button>
            </div>
          </div>
          <img width="500" class="pl-2" :src="imagePreview" alt="" />
          <!--
          <div class="mt-3">
            <button type="submit" class="btn btn-primary ml-3">Save</button>
          </div>
          -->
        </div>
      </form>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="feedPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Do you really want to leave? You have unsaved changes !
              </div>
            </div>
            <br />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="nextpage">leave</button>
              <button class="btn btn-outline ml-3" @click="feedPopup = false">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import courseAPI from '@/services/course';
import userInfo from '@/services/userInfo';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'topics',
  layout: 'admin',
  store,
  data() {
    return {
      userInfo: null,
      courseId: null,
      title: '',
      description: '',
      price: '',
      maxStudents: '',
      linear: false,
      Type: 'twitter',
      scheduled: false,
      Charge: false,
      PPP: false,
      publishDateTime: '',
      frequency: '',
      publish: true,
      image: null,
      Deliver: 'TWEET',
      imagePreview: '',
      img: '',
      courseData: null,
      feedPopup: false,
      autosave: null,
      nextpage: null,
      ischange: false,
      Limitstudent: false,
      sharingtips: false,
      Enablehashtag: false,
      Threadseries: false,
      showBackground: false,
      showCheck: false,
      showFeedback: false,
      showParticipate: false,
      showTakeaway: false,
      AllowsubmissionviaDM: false,
      creatorId: null,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    window.addEventListener('beforeunload', (e) => {
      if (this.ischange) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
    this.creatorId = this.$route.params.coursecreatorId;
    this.courseId = this.$route.params.courseId;
    this.userInfo = await userInfo.getUserInfo(this.creatorId);
    store.commit('toggleLoading', true);
    this.courseData = await courseAPI.getCourse(this.courseId);
    store.commit('toggleLoading', false);
    this.title = this.courseData.course.title;
    this.description = this.courseData.course.description;
    this.price = this.courseData.course.price;
    this.PPP = this.courseData.course.purchaseParityEnabled;
    this.Charge = this.courseData.course.price !== 0;
    this.maxStudents = this.courseData.course.maxStudents;
    this.linear = this.courseData.course.linear;
    this.scheduled = this.courseData.course.scheduled;
    this.publish = this.courseData.course.publish;
    this.Limitstudent = this.courseData.course.setStudentLimit;
    this.sharingtips = this.courseData.course.sharingtips;
    this.Enablehashtag = this.courseData.course.Enablehashtag;
    this.Threadseries = this.courseData.course.Threadseries;
    this.showBackground = this.courseData.course.showBackground;
    this.showCheck = this.courseData.course.showCheck;
    this.showFeedback = this.courseData.course.showFeedback;
    this.showParticipate = this.courseData.course.showParticipate;
    this.showTakeaway = this.courseData.course.showTakeaway;
    this.AllowsubmissionviaDM = this.courseData.course.AllowsubmissionviaDM;
    this.Type = this.courseData.course.type;
    this.Deliver = this.courseData.course.medium;
    const publishDateTimeISO = new Date(this.courseData.course.publishDateTime);
    publishDateTimeISO.setMinutes(
      publishDateTimeISO.getMinutes() - publishDateTimeISO.getTimezoneOffset(),
    );
    this.publishDateTime = publishDateTimeISO.toISOString().slice(0, 16);
    this.frequency = this.courseData.course.frequency;
    this.imagePreview = this.courseData.course.image;
    const imgParts = this.courseData.course.image.split('/');
    this.img = imgParts.at(-1);
  },
  beforeDestroy() {
    clearTimeout(this.autosave);
  },
  beforeRouteLeave(to, from, next) {
    if (this.ischange) {
      this.feedPopup = true;
      this.nextpage = next;
    } else {
      next();
    }
  },

  methods: {
    onImageUpload(e) {
      if (e.target.files.length > 0) {
        [this.image] = e.target.files;
        const data = URL.createObjectURL(this.image);
        this.imagePreview = data;
        console.log(data, 'data');
      }
    },
    onEdit() {
      console.log('edit');
      this.ischange = true;
      clearTimeout(this.autosave);
      this.autosave = setTimeout(() => this.autosaveCourse(), 10000);
    },
    async updateCourse() {
      let secureUrl = '';
      if (this.image !== null) {
        const cloudName = 'implicit';
        const formData = new FormData();
        formData.append('upload_preset', 'courses');
        formData.append('file', this.image);
        store.commit('toggleLoading', true);
        if (this.image) {
          const res = await axios
            .post(
              `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
              formData,
              {
                transformRequest: (data, headers) => {
                  // eslint-disable-next-line no-param-reassign
                  delete headers.common.Authorization;
                  return data;
                },
              },
            )
            .catch((e) => console.log(e));
          if (res) secureUrl = res.data.secure_url;
        }
      }
      const publishDateTime = new Date(this.publishDateTime);
      let payload = {
        title: this.title,
        description: this.description,
        price: this.price === '' ? 0 : this.price,
        maxStudents: this.maxStudents,
        linear: this.linear,
        scheduled: this.scheduled,
        publishDateTime: this.scheduled
          ? publishDateTime.getTime()
          : new Date().getTime(),
        frequency: this.scheduled ? this.frequency : '',
        publish: this.publish,
        currency: 'USD',
        purchaseParityEnabled: this.PPP,
        medium: this.Deliver,
        setStudentLimit: this.Limitstudent,
        sharingtips: this.sharingtips,
        Enablehashtag: this.Enablehashtag,
        Threadseries: this.Threadseries,
        showBackground: this.showBackground,
        showCheck: this.showCheck,
        showFeedback: this.showFeedback,
        showParticipate: this.showParticipate,
        showTakeaway: this.showTakeaway,
        AllowsubmissionviaDM: this.AllowsubmissionviaDM,
        type: this.Type,
      };
      if (secureUrl !== '') {
        payload = { ...payload, image: secureUrl };
      }
      courseAPI
        .updateCourse(this.courseId, payload)
        .then(() => {
          this.ischange = false;
          store.commit('toggleLoading', false);
          this.$router.push({ path: `/admin/course-creators/${this.creatorId}` });
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    async autosaveCourse() {
      // let secureUrl = '';
      // if (this.image !== null) {
      //   const cloudName = 'implicit';
      //   const formData = new FormData();
      //   formData.append('upload_preset', 'courses');
      //   formData.append('file', this.image);
      //   if (this.image) {
      //     const res = await axios
      //       .post(
      //         `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
      //         formData,
      //         {
      //           transformRequest: (data, headers) => {
      //             // eslint-disable-next-line no-param-reassign
      //             delete headers.common.Authorization;
      //             return data;
      //           },
      //         },
      //       )
      //       .catch((e) => console.log(e));
      //     if (res) secureUrl = res.data.secure_url;
      //   }
      // }
      // const publishDateTime = new Date(this.publishDateTime);
      // let payload = {
      //   title: this.title,
      //   description: this.description,
      //   price: this.price === '' ? 0 : this.price,
      //   maxStudents: this.maxStudents,
      //   linear: this.linear,
      //   scheduled: this.scheduled,
      //   publishDateTime: this.scheduled
      //     ? publishDateTime.getTime()
      //     : new Date().getTime(),
      //   frequency: this.scheduled ? this.frequency : '',
      //   publish: this.publish,
      //   currency: 'USD',
      //   purchaseParityEnabled: this.PPP,
      //   medium: this.Deliver,
      //   setStudentLimit: this.Limitstudent,
      //   sharingtips: this.sharingtips,
      //   Enablehashtag: this.Enablehashtag,
      //   showBackground: this.showBackground,
      //   showCheck: this.showCheck,
      //   showFeedback: this.showFeedback,
      //   showParticipate: this.showParticipate,
      //   showTakeaway: this.showTakeaway,
      //   AllowsubmissionviaDM: this.AllowsubmissionviaDM,
      //   type: this.Type,
      // };
      // if (secureUrl !== '') {
      //   payload = { ...payload, image: secureUrl };
      // }
      // courseAPI
      //   .updateCourse(this.courseId, payload)
      //   .then(() => {
      //     console.log('updated');
      //     this.ischange = false;
      //   })
      //   .catch((error) => {
      //     store.commit('toggleLoading', false);
      //     if (error.response.status === 401) {
      //       utils.setStatusMsg(
      //         this,
      //         'Unauthorized access, redirected to implicit',
      //       );
      //       this.$router.push({ path: '/' });
      //     }
      //     console.log({ error });
      //   });
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
